module.exports = __webpack_public_path__ + "img/media-fb.29d6147e.png";